import React, { useState, useEffect } from "react";
import Switch from '@mui/material/Switch';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import FullscreenLoader from "../../../components/Common/FullscreenLoader.jsx";
import "../../../styles/Auth/category.css";
import "../../../styles/Auth/product.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Box, Modal, Button,
} from '@mui/material';
import { Icon } from "@iconify/react";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { postData, getData, putData, uploadFile, deleteData } from "../../../webService/webservice.js";
import { toast } from "react-toastify";
import ViewCategoryPopup from './viewCategoryPopUp.jsx';
const CategoryPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddPage = location.pathname === '/category/add';
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        display: "flex",
        alignItems: 'center',
        justifyContent: "left"
    };
    const headings = [
        'SL',
        'Image',
        'Name',
        'Code',
        'Status',
        'Online',
        'Action',
    ];
    const [categoryImage, setCategoryImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [categories, setCategories] = useState([]);
    const [viewCategoryData, setViewCategoryData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [stores, setStores] = useState([]);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [open, setOpen] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editCategoryId, setEditCategoryId] = useState(null);
    const [categoryToDelete, setCategoryToDelete] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [limit, setLimit] = useState(5);
    const [refreshKey, setRefreshKey] = useState(0);
    const [formData, setFormData] = useState({
        categoryName: '',
        description: '',
        categoryImageObject: '',
        categoryCode: ''
    });
    const [errors, setErrors] = useState({});
    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };
    const handleAddCategory = async (e) => {
        e.preventDefault();
        let newErrors = {};

        if (!formData.categoryName.trim()) {
            newErrors.categoryName = "Category Name is required.";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;
        setLoading(true);
        try {
            const token = sessionStorage.getItem("sessionToken");
            const userId = sessionStorage.getItem("userId");
            if (userId) {
                let uploadResult;
                if(categoryImage) {
                    uploadResult = await uploadFile(`files/upload/${userId}`, categoryImage);
                    if (uploadResult?.status === 200) {
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                    }
                }
                
                // Build the full image URL
                const categoryData = {
                    categoryName: formData.categoryName,
                    description: formData.description,
                    categoryImageObject: uploadResult?.data,
                    categoryCode: formData.categoryCode
                };
                console.log("Sending category data:", categoryData);

                const response = await postData('categories/', categoryData, token);

                toast.success(response.message || 'Category added successfully');
                setFormData({ categoryName: '', description: '', categoryImageObject: null, categoryCode: '' });
                setCategoryImage(null);
                setPreviewUrl(null);
                navigate("/category");
                triggerRefresh();
            }
        } catch (error) {
            console.error('Add Category Error:', error);
            toast.error(error.message || 'Add Category Failed');
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateCategory = async (e) => {
        e.preventDefault();
        let newErrors = {};

        if (!formData.categoryName.trim()) {
            newErrors.categoryName = "Category Name is required.";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;
        setLoading(true);
        try {
            const token = sessionStorage.getItem("sessionToken");
            const userId = sessionStorage.getItem("userId");

            let updatedImageObject = formData.categoryImageObject;

            if (categoryImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, categoryImage);

                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }


            const updatedCategoryData = {
                categoryName: formData.categoryName,
                description: formData.description,
                categoryImageObject: updatedImageObject,
                categoryCode: formData.categoryCode
            };

            console.log("Updating category with data:", updatedCategoryData);

            const response = await putData(`categories/category/${editCategoryId}`, updatedCategoryData, token);

            toast.success(response.message || 'Category updated successfully');

            // Step 4: Reset form and close modal
            setFormData({ categoryName: '', description: '', categoryImageObject: null, categoryCode: '' });
            setCategoryImage(null);
            setPreviewUrl(null);
            setIsPopupMode(false);
            setIsEditMode(false);   
            triggerRefresh();
        } catch (error) {
            toast.error("Error updating category.");
        } finally {
            setLoading(false);
        }
    };

    const handleViewCategory = async (categoryId) => {
        try {
            setLoading(true);

            // Assuming sessionToken is from sessionStorage
            const sessionToken = sessionStorage.getItem("sessionToken");

            // Fetch data using your getData function
            const response = await getData(`categories/category/${categoryId}`, sessionToken);

            // Check if response is already JSON
            const data = response?.data || response;

            // Set the view data
            setViewCategoryData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching category:", error);
            toast.error(error.message || "Failed to fetch category data");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteCategory = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = sessionStorage.getItem('sessionToken');
            const response = await deleteData(`categories/category/${categoryToDelete}`, token);
            toast.success(response.message || "Category deleted successfully");
            setCategoryToDelete(null);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete category");
        } finally {
            setLoading(false);
        }
    }

    const handleToggle = async (categoryId, newStatus) => {
        try {
            setLoading(true);
            const token = sessionStorage.getItem("sessionToken");

            const response = await putData(
                `categories/toggle-status/${categoryId}`,
                { isActive: newStatus },    // send true or false
                token
            );

            toast.success(response.message || "Status updated!");

            triggerRefresh();
        } catch (error) {
            console.error("Toggle Error:", error);
            toast.error("Failed to update status");
        } finally {
            setLoading(false);
        }
    };

    const handleToggleOnline = async (categoryId, newStatus) => {
        try {
            setLoading(true);
            const token = sessionStorage.getItem("sessionToken");

            const response = await putData(
                `categories/toggle-online-status/${categoryId}`,
                { isOnline: newStatus },    // send true or false
                token
            );

            toast.success(response.message || "Status updated!");

            triggerRefresh();
        } catch (error) {
            console.error("Toggle Error:", error);
            toast.error("Failed to update status");
        } finally {
            setLoading(false);
        }
    };

    // Fetch categories whenever page, limit, searchQuery, or selectedStoreId changes
    useEffect(() => {
        setLoading(true);
        const fetchCategories = async () => {
            try {
                const params = {
                    page: currentPage,
                    limit,
                    categoryName: searchQuery?.trim() || "",
                };
                const data = await getData('categories/categories', params, sessionToken);
                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setCategories(results);
                setTotalPages(data?.data?.results?.[0]?.totalPages || 1);
                setTotalCount(data?.data?.results?.[0]?.totalCount || 0);
                
            } catch (error) {
                toast.error(error.message || "Failed to fetch categories");
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, [currentPage, limit, refreshKey, searchQuery]);

    const handleOpen = (categoryId) => {
        setCategoryToDelete(categoryId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCategoryToDelete(null);
    };



    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#e6cf80',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    return (
        <div className="category-layout">
            {loading && <FullscreenLoader />}
            <div className="category-content">
                <main className="category-main">
                    {isAddPage ? (
                        <div className="add-category-form">
                            <h3>Add Category</h3>
                            <form className="category-form">
                                <div className="category-form-row">
                                    <div className="category-form-group">
                                        <label htmlFor="categoryName" className="input-label">
                                            Category Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter category name"
                                            className={`category-input ${errors.categoryName ? "input-error" : ""}`}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, categoryName: e.target.value }))
                                            }
                                        />
                                        {errors.categoryName && (
                                            <p className="error-msg">{errors.categoryName}</p>
                                        )}
                                    </div>

                                    <div className="category-form-group">
                                        <label htmlFor="description" className="input-label">
                                            Description
                                        </label>
                                        <input
                                            type="text"
                                            id="description"
                                            placeholder="Enter description"
                                            className="category-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, description: e.target.value }))
                                            }
                                        />
                                    </div>

                                    <div className="category-form-group">
                                        <label htmlFor="categoryImage" className="input-label">
                                            Category Image
                                        </label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            id="categoryImage"
                                            className="category-input"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setCategoryImage(file);
                                                setPreviewUrl(URL.createObjectURL(file));
                                            }}
                                        />
                                        {previewUrl && (
                                            <div className="image-preview">
                                                <img src={previewUrl} alt="Preview" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="category-buttons">
                                    <button className="add-category-button" onClick={handleAddCategory}>
                                        add category
                                    </button>
                                    <button className="cancel-category-button" onClick={() => navigate('/category')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className="category-widgets">
                                <div className="category-widgets-header">
                                    <h3>categories</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="category-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <button
                                    className="add-btn-category"
                                    onClick={() => navigate('/category/add')}
                                >
                                    + Add category
                                </button>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                overflow: 'outo',
                                maxHeight: '400px',
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none'
                            }}>
                                <Table className="custom-category-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-category-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                            alignItems: 'center',
                                                            justifyContent: "left"
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {categories.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No categories found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            categories.map((cat, index) => (
                                                <TableRow key={cat._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                                                            <img
                                                                src={`${process.env.REACT_APP_API_URL}${cat.categoryImageObject?.uri}` || "/assets/placeholder.png"}
                                                                alt={cat.name}
                                                                style={{ width: 40, height: 40, borderRadius: '4px' }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{cat.name || cat.categoryName}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{cat.categoryCode}</Typography>
                                                    </TableCell>
                                                    <TableCell >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                                                            <Switch
                                                                checked={cat.isActive}
                                                                onChange={(e) => handleToggle(cat._id, e.target.checked)}   // send id + status
                                                                sx={{
                                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                                        color: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                        backgroundColor: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-track': {
                                                                        backgroundColor: '#C10000',
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                                                            <Switch
                                                                checked={cat.isOnline}
                                                                onChange={(e) => handleToggleOnline(cat._id, e.target.checked)}   // send id + status
                                                                sx={{
                                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                                        color: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                        backgroundColor: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-track': {
                                                                        backgroundColor: '#C10000',
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'left' }}>
                                                            <Icon icon={plusIcon} width={20} height={20} style={{ cursor: 'pointer' }} onClick={() => handleViewCategory(cat._id)} />
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    categoryName: cat.categoryName || cat.name || '',
                                                                    description: cat.description || '',
                                                                    storeId: cat.storeId?._id || cat.storeId || "",
                                                                });
                                                                setPreviewUrl(
                                                                    cat?.categoryImageObject?.uri
                                                                        ? `${process.env.REACT_APP_API_URL}${cat.categoryImageObject.uri}`
                                                                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                );
                                                                setCategoryImage(null);
                                                                setEditCategoryId(cat._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: 'pointer' }}
                                                                onClick={() => handleOpen(cat._id)}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="category-bottom">
                                <div className="category-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select"
                                        value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="category-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="category-section spacer"></div>
                                <div className="category-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Category" : "Add Category"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateCategory}>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="categoryName">Category Name<span className="required">*</span></label>
                                                        <input
                                                            type="text"
                                                            id="categoryName"
                                                            placeholder="Enter category name"
                                                            className={`category-input ${errors.categoryName ? "input-error" : ""}`}
                                                            value={formData.categoryName}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    categoryName: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                        {errors.categoryName && (
                                                            <p className="error-msg">{errors.categoryName}</p>
                                                        )}
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="description">Description</label>
                                                        <input
                                                            type="text"
                                                            id="description"
                                                            placeholder="Enter description"
                                                            value={formData.description}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    description: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="categoryImage">Category Image</label>
                                                        <input
                                                            type="file"
                                                            id="categoryImage"
                                                            accept="image/*"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                setCategoryImage(file);
                                                                setPreviewUrl(URL.createObjectURL(file));
                                                            }}
                                                        />
                                                        {previewUrl && (
                                                            <div className="image-preview">
                                                                <img src={previewUrl} alt="Preview" />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update Category" : "Add Category"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && categories.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more categories
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this category?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: "#8D2629 " }} onClick={handleDeleteCategory}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                            {openViewPopup && (
                                <ViewCategoryPopup
                                    data={viewCategoryData}
                                    onClose={() => setOpenViewPopup(false)}
                                />
                            )}

                        </>
                    )}
                </main>
            </div>
        </div>

    );
};

export default CategoryPage;